import React from "react";
import "./title.css";
import classNames from "classnames";

const Title = (props) => {
  const { type, children, displayEffect } = props;
  return (
    <div
      className={classNames(type + "_title", {
        " display-effect": displayEffect,
      })}
    >
      {children}
    </div>
  );
};
export default Title;
